import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cs from '../../utils/classes';
import { addResizeEventListener } from '../../utils/elementResizeEvent';
import Render from '../Render';

var AutoSizer = function (_Component) {
  _inherits(AutoSizer, _Component);

  function AutoSizer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AutoSizer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AutoSizer.__proto__ || _Object$getPrototypeOf(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      width: _this.props.initialWidth,
      height: _this.props.initialHeight

      /**
       * @public
       * @returns {void}
       */
    }, _this.containerNode = null, _this._removeResizeEventListener = null, _this._containerRef = function (node) {
      _this.containerNode = node;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  /**
   * @public
   * @var {object}
   */


  _createClass(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var containerNode = this.containerNode;


      this._removeResizeEventListener = addResizeEventListener(containerNode, function (size) {
        var _state = _this2.state,
            width = _state.width,
            height = _state.height,
            containerNode = _this2.containerNode;

        var style = getComputedStyle(containerNode);
        var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(style.paddingRight, 10) || 0;
        var paddingTop = parseInt(style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
        var nextWidth = size.width - paddingLeft - paddingRight;
        var nextHeight = size.height - paddingTop - paddingBottom;

        if (nextHeight !== height || nextWidth !== width) {
          _this2.setState({
            width: nextWidth,
            height: nextHeight
          });
        }
      });
    }

    /**
     * @public
     * @returns {void}
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._removeResizeEventListener) {
        this._removeResizeEventListener();
      }
    }

    /**
     * @public
     * @var {HTMLElement}
     */


    /**
     * @private
     * @var {function}
     */


    /**
     * @private
     * @param {HTMLElement} node
     * @returns {void}
     */

  }, {
    key: 'render',


    /**
     * @public
     * @returns {object}
     */
    value: function render() {
      var _props = this.props,
          initialWidth = _props.initialWidth,
          initialHeight = _props.initialHeight,
          component = _props.component,
          render = _props.render,
          classNameProp = _props.className,
          children = _props.children,
          otherProps = _objectWithoutProperties(_props, ['initialWidth', 'initialHeight', 'component', 'render', 'className', 'children']),
          _state2 = this.state,
          width = _state2.width,
          height = _state2.height,
          _containerRef = this._containerRef;

      var className = cs(classNameProp);

      return React.createElement(
        'div',
        _extends({}, otherProps, {
          ref: _containerRef,
          className: className
        }),
        Render({
          component: component,
          render: render,
          children: children,
          width: width,
          height: height
        })
      );
    }
  }]);

  return AutoSizer;
}(Component);

if (process.env.NODE_ENV !== 'production') {
  AutoSizer.propTypes = {
    initialWidth: PropTypes.number,
    initialHeight: PropTypes.number,
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    render: PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    className: PropTypes.any,
    children: PropTypes.func
  };
}

export default AutoSizer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/components/AutoSizer/AutoSizer.js
// module id = 787
// module chunks = 0